export default {
  //用户列表
  userManagement: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/user-management/list.vue'));
    }, '/modules/user-management/list');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/user-management.js